import {
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import React from "react";
import serachIcon from "assets/images/svg-icons/Search.svg";

const SearchInput = ({
  className,
  onChange,
  onBlur,
  value,
  error,
  placeholder = "commonButton.search",
  name,
  isBold = false,
  fullWidth = true,
  disabled = false,
  variant = "light",
  rows = 3,
  multiline = false,
  isNumeric = false,
  maxLength = 10,
  isTextOnly = false,
  endAdornment = <></>,
  ref,
  height,
  src,
  ...rest
}) => {
  const { sx, ...restProps } = rest;

  const handleInputChange = (e) => {
    let inputValue = e.target.value;

    if (isNumeric) {
      inputValue = inputValue.replace(/\D/g, "").slice(0, maxLength);
    }

    if (isTextOnly) {
      inputValue = inputValue.replace(/[^a-zA-Z\s]/g, "");
    }

    if (ref?.current) {
      ref.current.value = inputValue;
    }

    onChange?.({
      target: {
        name,
        value: inputValue,
      },
    });
  };

  return (
    <FormControl fullWidth={fullWidth} error={Boolean(error)}>
      <OutlinedInput
        inputRef={ref}
        variant={variant}
        id={name}
        multiline={multiline}
        rows={rows}
        className={className}
        onChange={handleInputChange}
        onBlur={onBlur}
        value={value}
        placeholder={placeholder}
        autoComplete="new-password"
        name={name}
        disabled={disabled}
        startAdornment={
          <InputAdornment
            position="start"
            sx={{ m: 0, mr: "8px" }}
          >
            <IconButton
              disableRipple
              tabIndex={-1}
              sx={{
                p: 0,
                m: 0,
                cursor: "default",
              }}
            >
              <img
                width="16"
                height="16"
                src={src ?? serachIcon}
                alt="search"
              />
            </IconButton>
          </InputAdornment>
        }
        endAdornment={
          endAdornment ? (
            <InputAdornment
              position="end"
              sx={{ m: 0, ml: "8px" }}
            >
              {endAdornment}
            </InputAdornment>
          ) : null
        }
        sx={{
          p: "0 12px",
          bgcolor: "transparent",
          width: "100%",
          height,
          "& .MuiInputBase-input": {
            p: 0,
            minWidth: 0,
            fontSize: "14px",
            color: "#1D1C20",
            fontWeight: isBold ? 500 : 400,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #DCDCDE !important",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: error
              ? "#F9A3A3 !important"
              : "hsla(216, 14%, 21%, 1) !important",
          },
          ...sx,
        }}
        {...restProps}
      />
    </FormControl>
  );
};

export default SearchInput;
